import * as R from 'ramda'
import DOMPurify from "dompurify";

export const onFormElementChange = (formState, setFormState, currentFormState, field) => {
  const lensFor = R.lensPath(['value', field]);
  const newValue = R.set(lensFor, currentFormState[field], currentFormState);
  const newState = { value: newValue, errors: R.omit([field], formState.errors) }
  setFormState(newState)
}

export const setFormErrors = (formState, setFormState, errors) => {
  const newState = {...formState, errors: errors}
  setFormState(newState)
}

export const cleanupFormValue = formValue => {
  return R.map((partFormValue) => {
    return R.map(value => {
      if(R.is(Array, value)) {
        return R.map(innerValue => {
          return DOMPurify.sanitize(innerValue, {ALLOWED_TAGS: []});
        }, value)
      }
      return DOMPurify.sanitize(value, {ALLOWED_TAGS: []});
    }, partFormValue)
  }, formValue)
}